import type { PaletteOptions } from '@mui/material/styles';

export const palette: PaletteOptions = {
  mode: 'light',
  primary: {
    main: '#0D47A1',
    light: '#5472D3',
    dark: '#002171',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#1565C0',
    light: '#5E92F3',
    dark: '#003C8F',
    contrastText: '#FFFFFF',
  },
  error: {
    main: '#D32F2F',
    light: '#EF5350',
    dark: '#C62828',
  },
  warning: {
    main: '#ED6C02',
    light: '#FF9800',
    dark: '#E65100',
  },
  info: {
    main: '#0288D1',
    light: '#03A9F4',
    dark: '#01579B',
  },
  success: {
    main: '#2E7D32',
    light: '#4CAF50',
    dark: '#1B5E20',
  },
  background: {
    default: '#F5F7FA',
    paper: '#FFFFFF',
  },
  text: {
    primary: '#1A237E',
    secondary: '#455A64',
    disabled: '#9E9E9E',
  },
  divider: '#E0E0E0',
};
